import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface NextTierProgressProps {
  nextTier?: string;
  progress?: number;
  neededClients?: number;
  neededVolume?: number;
}

const NextTierProgress = ({
  nextTier = 'Platinum Tier',
  progress = 75,
  neededClients = 12,
  neededVolume = 250000,
}: NextTierProgressProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Next Tier Progress</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <div className="flex justify-between text-sm mb-1">
              <span>{nextTier}</span>
              <span>{progress}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-yellow-500 h-2 rounded-full"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
          <div className="text-sm text-gray-600">
            <p>Need {neededClients} more clients</p>
            <p>or ${neededVolume.toLocaleString()} more volume</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NextTierProgress;
